import {Determinant} from "./determinant";

/**
 * FileUploadDeterminant handles file upload-related events.
 * This is a field determinant (determinantType = "FORMFIELD") with discriminator "FileUpload".
 *
 * Supported file upload events:
 * - change: File is uploaded/changed
 */
export class FileUploadDeterminant extends Determinant {

  public fileUploadEventName: string;
  public determinantType = "FORMFIELD";

  /**
   * The file upload component key (stored in sourceFormFieldKey in base Determinant)
   */
  public get fileUploadKey(): string {
    return this.sourceFormFieldKey;
  }

  public set fileUploadKey(value: string) {
    this.sourceFormFieldKey = value;
  }

}
